import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {CommunesList, Coordinate, GeoSpacialData, Inofrmations, SpacialData} from "../models/response.model";
import {environment} from "../../environments/environment";
import OlXYZ from "ol/source/XYZ";
import XYZ from "ol/source/XYZ";
// import OlLayerTile from 'ol/layer/Tile';
import OlSourceTileWMS from 'ol/source/TileWMS';
import OlTileLayer from "ol/layer/Tile";
import  TileLayer from "ol/layer/Tile";
import OlView from "ol/View";
import View from "ol/View";
import ImageLayer from "ol/layer/Image";
import {AppService} from "../app.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Circle, Fill, Stroke, Style} from "ol/style";
import {Feature, MapBrowserEvent} from "ol";
import proj4 from 'proj4';
import {register} from "ol/proj/proj4";
import {ImageWMS, OSM} from "ol/source";
import Overlay from "ol/Overlay";
import Map from "ol/Map";
import {Group} from "ol/layer";
import {Attribution, ScaleLine, Zoom} from "ol/control";
import {toStringHDMS, toStringXY} from "ol/coordinate";
import {toLonLat} from "ol/proj";
import Geolocation from "ol/Geolocation";
import {Point} from "ol/geom";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {any} from "codelyzer/util/function";
// import '../audit/logging-sms/assets/css/bootstrap.css';


declare let $: any;
declare var bootstrap: any;

class cdt implements Coordinate {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

}

@Component({
  selector: 'app-mapv2',
  templateUrl: './mapv2.component.html',
  styleUrls: ['./mapv2.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Mapv2Component implements OnInit {

  commune: CommunesList = [];
  radarStyle: { [key: string]: string } = {};
  radarActive = true;
  coord: any;
  config = environment;
  url = this.config.GEOSERVER_URL + `/geoserver/${this.config.GEOSERVER_WORKSPACE}/wms`;
  map;
  spacialInformation: SpacialData = {};
  dataInformation: GeoSpacialData = {};
  source: OlXYZ;
  // @ts-ignore
  layers: OlTileLayer;
  view: OlView;
  defaultNameSpace = 'efb:efb_parcel';
  zoneDeclarerNameSpace = 'efb:parcel_zone_declaree';
  // defaultNameSpace = 'efb:efb_parcel_prod';
  defaultCoordinate: cdt = new cdt(432371.96549791255, 909226.3631854871)
  googleStatLayers: OlTileLayer<any>;
  osmLayers: TileLayer<any>;
  beninOrthoLayer: ImageLayer<any>;
  olgmLayers: OlTileLayer<any>;
  sourceLayersnum: ImageLayer<any>;
  sourceLayerClic: ImageLayer<any>;
  sourceLayersvilage: ImageLayer<any>;
  sourceLayers: ImageLayer<any>;
  zoneDeclareLayersZhs: ImageLayer<any>;
  zoneDeclareLayersPag: ImageLayer<any>;
  zoneDeclareLayersZdup: ImageLayer<any>;
  zoneDeclareLayersDpn: ImageLayer<any>;
  loading = false;
  village: any;
  search: any
  positionFeature = new Feature();
  accuracyFeature = new Feature();
  showForm = false;
  code
  showZoneDeclare = false;
  enablegeoLocation: boolean = false;
  display = 'none';
  private defauldtZoom: number = this.config.OPENLAYERS_MIN_ZOOM;

  constructor(
    private _appServices: AppService,
    private activatedroute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _router: Router,
    public dialog: MatDialog,
    private elRef: ElementRef
  ) {
    this.positionFeature.setStyle(new Style({
      image: new Circle({
        radius: 6,
        fill: new Fill({
          color: 'rgba(16,160,95,0.83)'
        }),
        stroke: new Stroke({
          color: 'rgba(255,255,255,0.55)',
          width: 2
        })
      })
    }));
  }

  ngOnInit(): void {
    // try find by nup
  this.code =  this.activatedroute.snapshot.paramMap.get('nup');
    if (this.code) {
      this.getInformation()
      this.buildZonDeclare();
    } else {
      //  this.communes();
      this.initilizeMap()
      this.flyTo([this.defaultCoordinate.x, this.defaultCoordinate.y], function () {
      }, this.defauldtZoom)
      this.showForm = false;
      this.buildZonDeclare();
    }
  }

  initilizeMap() {
    const color = '';
    let styleNew = new Style({
      stroke: new Stroke({
        color: color,
        width: 7,
      })
    });
    proj4.defs(
      'EPSG:32631',
      '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs',
    );
    register(proj4);
    const mwsSources2 = new ImageWMS({
      // url: 'https://cadastre.bj/geoserver/benin/wms',
      url: this.url,
      params: {'LAYERS': 'andf-ortho'},
      ratio: 1,
      serverType: 'geoserver',
    });
    // console.log(this.village, this.code)
    const mwsSourcesnup = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace, 'CQL_FILTER': 'nup=' + this.code, 'STYLES': 'sst'},
      ratio: 1,
      serverType: 'geoserver',
    });
    const mwsSourcesVillage = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace, 'CQL_FILTER': `quartier_name='${this.village}' `},
      ratio: 1,
      serverType: 'geoserver',
    });
    const mwsSources = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace},
      ratio: 1,
      serverType: 'geoserver',
    });

    const zoneDeclareSources = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': 'efb:parcel_zone_declaree'},
      ratio: 1,
      serverType: 'geoserver',
    });

   /* const  newLayers = new OlLayerTile({
      source: new OlSourceTileWMS({
        url: 'https://sgx.geodatenzentrum.de/wms_topplus_open',
        params: {
          'LAYERS': 'web_light_grau'
        }
      }),
      visible: false
    }
      );*/
    // vue par defaut
    let views = new View({
      center: [this.defaultCoordinate.x, this.defaultCoordinate.y],
      projection: 'EPSG:32631',
      zoom: this.defauldtZoom,
      minZoom: this.config.OPENLAYERS_MIN_ZOOM
    });
    // google layer
    this.googleStatLayers = new TileLayer({
      source: new XYZ({
        url: 'http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}'
      }),
      visible: false,
      opacity: 0.5
    });
// Benin ortho photo
    this.beninOrthoLayer = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSources2,
      visible: false,
      opacity: 0.7
    })

    const olgmLayersSource =new XYZ({
        url: 'http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}'
      })

    this.osmLayers = new TileLayer({
      source: olgmLayersSource,
      visible: true,
      opacity: 0.7
    })

    this.sourceLayers = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSources,
      opacity: 0.7,
    })

   /* this.zoneDeclareLayers = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: zoneDeclareSources,
      opacity: 0.7,
      visible:false
    })*/

    this.sourceLayersvilage = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesVillage,
      opacity: 0.7,
      visible: true
    })

    this.sourceLayersnum = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesnup,
      opacity: 0.7,
      visible: true,
      // minZoom: 18
    })

    if (this.code) {
      this.sourceLayers.setVisible(false)
      this.sourceLayersnum.setOpacity(1)
      this.sourceLayersnum.setZIndex(1)
      views = new View({
        center: [this.spacialInformation.data.coordinate.x, this.spacialInformation.data.coordinate.y],
        projection: 'EPSG:32631',
        zoom: this.getZoom(this.spacialInformation.data.calculatedArea),
        minZoom: 8
      });
    }
    // show coordonate
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    // const closer = document.getElementById('popup-closer');
    /**
     * Create an overlay to anchor the popup to the map.
     */
    const overlay = new Overlay({
      element: container,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });
    /**
     * Add a click handler to hide the popup.
     * @return {boolean} Don't follow the href.
     */
    /*  closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };*/

    const layers = [
      new TileLayer({
        source: new OSM({
          attributions: ''
        }),
        visible: true
      }),

      this.beninOrthoLayer,
      this.googleStatLayers,
      this.sourceLayers,
      this.sourceLayersvilage,
      this.sourceLayersnum,
      // this.zoneDeclareLayers
    ];

    this.map = new Map({
      layers: new Group({
        layers: layers,
      }),
      overlays: [overlay],
      target: 'map',
      view: views,

    });


    this.map.getControls().forEach(control => {
      console.log('contole ', control)
      if (control instanceof Zoom) {
        this.map.removeControl(control);

      }
      if (control instanceof Attribution) {
        this.map.removeControl(control);
      }
    });
    this.map.getControls().clear();
    this.map.addControl(new ScaleLine({
      target: document.getElementById('scaleline'),
    }))
    // @ts-ignore
    this.map.on('onload', (evt: MapBrowserEvent): void => {
      console.log('event ', evt);
      let url = mwsSources.getFeatureInfoUrl(
        evt.coordinate,
        views.getResolution(),
        views.getProjection(), {
          'INFO_FORMAT': 'application/json'
        });


      if (url) {
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            this.spacialInformation = data.features[0].properties
            let d = data.features[0].properties
            console.log('data  local', d.local_parcel_identification)
            this.getInfoFromLocalStorage(d)
          }).catch(error => {
          console.error('There has been a problem with your fetch operation:', error);
        });
        // this.map.zoomToMaxExtent();
      }
    });

    this.map.on('loadstart', () => {
      this.map.getTargetElement().classList.add('spinner');
    });
    this.map.on('loadend', () => {
      this.map.getTargetElement().classList.remove('spinner');
    });

    // @ts-ignore
    this.map.on('singleclick', (evt: MapBrowserEvent) => {
      // console.log('event ', evt);
      // console.log('Cordinate. ', evt.coordinate);
      // this.centerMap(evt.coordinate)
      let url = mwsSources.getFeatureInfoUrl(
        evt.coordinate,
        views.getResolution(),
        views.getProjection(), {
          'INFO_FORMAT': 'application/json'
        });
      console.log('url ', url);
      if (url) {
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            this.spacialInformation = data.features[0].properties
            let d = data.features[0].properties

            this.map.removeLayer(this.sourceLayerClic)
            this.map.getLayers().array_.push(this.clicLayer(d.nup))
            // console.log('layers',  this.map.getLayers().array_)
            // this.map.getLayers().array_.push(this.clicLayer(d.nup))
            this.flyTo(evt.coordinate, () => {
              this.getInfoFromLocalStorage(d)
              console.log('data  local', d.local_parcel_identification)
            }, this.getZoom(d.calculated_area))
            // this.centerMap(evt.coordinate, d.calculated_area)

            // this.map.setLayers(this.clicLayer(d.nup))
          });
        // this.map.zoomToMaxExtent();
      }
      this.showForm = false;
    });
    /**
     * Add a click handler to the map to render the popup.
     */

    var div = document.getElementsByClassName("ol-scale-line");
    const newDiv = document.createElement("div");
    newDiv.className = 'ol-scale-line-inner';
    const newContent = document.createTextNode("|");
    newDiv.appendChild(newContent);
    div[0].appendChild(newDiv)
    // div= newDiv;
    // var div =  document.getElementsByClassName("ol-scale-line-inner");

    // this.map.on('pointermove', function (evt) {
    this.map.on('pointermove', function (evt) {
      const coordinate = evt.coordinate;
      const hdms = toStringHDMS(toLonLat(coordinate));

      newDiv.innerHTML = toStringXY(coordinate, 1);

      // console.log('div ',div)

      // div.innerHTML =div.innerHTML+ '| '+toStringXY(coordinate,1);


      // var newDiv = document.getElementById("cdt").innerHTML= '<code>' + toStringXY(coordinate,1) + '</code>';
      // var newDiv = document.getElementById("cdt").innerHTML= '<code>' + toStringXY() toLonLat(coordinate) + '</code>';
      // newDiv.children.namedItem("div").innerHTML = '<code>' + toLonLat(coordinate) + '</code>';

      // content.innerHTML = '<code>' + hdms + '</code> <br> <code>' +toStringXY(coordinate,1)+ '</code>';
      // content.innerHTML = '<p>You clicked here:</p><code>' + hdms + '</code>';
      // overlay.setPosition(coordinate);
    });

  }

  flyTo(location, done, pZoom) {
    const duration = 4000;
    const view = this.map.getView();

    let zoom = this.defauldtZoom;
    if (pZoom) {
      zoom = pZoom
    }
    let parts = 2;
    let called = false;

    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0 || !complete) {
        called = true;
        done(complete);
      }
    }

    view.animate(
      {
        center: location,
        duration: duration,
      },
      callback
    );
    view.animate(
      {
        zoom: zoom - 1,
        duration: duration / 2,
      },
      {
        zoom: zoom,
        duration: duration / 2,
      },
      callback
    );
  }

  centerMap(c, calculatedArea) {
    console.log("c: " + c);

    this.map.getView().setCenter(c, 'EPSG:32631');
    // this.map.getView().animate({
    //     center: c,
    //     duration: 2000,
    //     projection: 'EPSG:32631'
    //     // easing: elastic,
    //   }
    // )
    if (calculatedArea) {
      console.log('Zoom : ', this.getZoom(calculatedArea))
      this.map.getView().setZoom(this.getZoom(calculatedArea));
    } else {
      this.map.getView().setZoom(this.defauldtZoom);
    }


  }

  getInfoFromLocalStorage(d) {

    console.log('data ', d)
    this.dataInformation = d;
    this.openModal();
    //let info = JSON.parse(localStorage.getItem('INFO'))
    /* this.nup = d.nup;
     this.code = d.nup;
     this.Tfoncier = d.title_number_number;
     this.Dep = d.departement_name;
     this.Com = d.commune_name;
     this.Arr = d.arrondissement_name;
     this.Qrtier = d.quartier_name;
     this.lot = d.ilot;
     this.Surface = d.calculated_area;
     this.Parcelle = d.register_type;
     if (this.Parcelle === "publicDomain") {
       this.Parcelle = 'Domaine public'
     } else if (this.Parcelle === "privateParcel") {
       this.Parcelle = 'Parcelle privée'
     } else if (this.Parcelle === "naturalPublicDomain") {
       this.Parcelle = 'Domaine public naturel'
     }
     this.DateF = "-";
     $("#myModal").modal('show')
     $("#myModal").on("hidden.bs.modal", () => {
       // put your default event here
       this.sourceLayerClic.setVisible(false);
       // console.log("closed .....",this.map.getLayers().array_.length)
       // this.map.getLayers().array_.pop()
       // console.log("closed .....",this.map.getLayers().array_.length)

     });*/
    //  return info
  }

  getInformation() {
    console.log("get information")
    this.loading = true;
    this._appServices.getNupInfo(this.code).subscribe((res: SpacialData) => {
        console.log("get res information", res)
        if (res.message === "ParcelExists") {
          let data = res.data;
          this.spacialInformation = res;
          this.village = data.quartierName
          this.initilizeMap();
          this.extractedDataInformation(data);
          // this.spacialInformation = res;

          // this.clicLayer(this.code)
          // console.log(res.data)
          this.openModal();
          this.loading = false;
        } else if (res.message === "ParcelNotExists") {
          this.code = null;
          this.initilizeMap()
          this.loading = false;
          setTimeout(() => {
            this._snackBar.open("Parcelle non trouvée", "Fermer");
          }, 3000);

        }


        /*
          if (res.message === "ParcelExists") {
             let d = res.data
             // this.village = "'" + d.quartierName + "'"
             this.village = d.quartierName
             console.log(this.village)
             this.nup = d.nup;
             this.Tfoncier = d.titleNumberNumber;
             this.Dep = d.departementName;
             this.Com = d.communeName;
             this.Arr = d.arrondissementName;
             this.Qrtier = d.quartierName;
             this.lot = d.ilot;
             this.Surface = d.calculatedArea;
             this.Parcelle = d.registerType;
             if (this.Parcelle === "publicDomain") {
               this.Parcelle = 'Domaine public'
             } else if (this.Parcelle === "privateParcel") {
               this.Parcelle = 'Parcelle privée'
             } else if (this.Parcelle === "naturalPublicDomain") {
               this.Parcelle = 'Domaine public naturel'
             } else if (this.Parcelle === "artificialPublicDomain") {
               this.Parcelle = 'Domaine public artificiel'
             }
             this.DateF = "-";
             this.initilizeMap()
             setTimeout(() => {
               this._snackBar.open("Parcelle trouvée", "Fermer",);
             }, 3000);
           }
           else if (res.message === "ParcelNotExists") {
             this.initilizeMap()
             setTimeout(() => {
               this._snackBar.open("Parcelle non trouvée", "Fermer");
             }, 3000);

           }*/

      },
      error => {
        console.error("Error ", error)
        this.code = null;
        this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Une erreur s'est produite", "Fermer");
        }, 3000);
      })
  }

  private extractedDataInformation(data: Inofrmations) {
    this.dataInformation.title_number_commune_name = data.titleNumberNumber;
    this.dataInformation.quartier_name = data.quartierName;
    this.dataInformation.title_number_number = data.titleNumberNumber;
    this.dataInformation.arrondissement_name = data.arrondissementName;
    this.dataInformation.quartier_name = data.quartierName;
    this.dataInformation.arrondissement_oid_local_id = data.arrondissementOidLocalId;
    this.dataInformation.arrondissement_name = data.arrondissementName;
    this.dataInformation.commune_name = data.communeName;
    this.dataInformation.departement_name = data.departementName;
    this.dataInformation.arrondissement_insae_code
    this.dataInformation.nup = data.nup
    this.dataInformation.calculated_area = data.calculatedArea;
    this.dataInformation.register_type = data.registerType;
    // @ts-ignore
    this.dataInformation.local_parcel_identification= data.localParcelIdentification;
  }

  zoomIn() {
    // Fonction pour effectuer un zoom avant
    const view = this.map.getView();
    const currentZoom = view.getZoom();
    view.setZoom(currentZoom + 1);
  }

  zoomOut() {
    // Fonction pour effectuer un zoom avant
    const view = this.map.getView();
    const currentZoom = view.getZoom();
    view.setZoom(currentZoom - 1);
  }

  clicLayer(nup) {
    const mwsSourcesnup = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.defaultNameSpace, 'CQL_FILTER': 'nup=' + nup, 'STYLES': 'sst'},
      ratio: 1,
      serverType: 'geoserver',

    });
    this.sourceLayerClic = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesnup,
      opacity: 0.8,
      visible: true,
      // minZoom: 18


    })
    return this.sourceLayerClic;
  }

  buildAddionnional(layerName, cqlFilter?, style?) {
   /* const mwsSourcesnup = new ImageWMS({
      // url: 'https://ahocevar.com/geoserver/wms',
      url: this.url,
      params: {'LAYERS': this.zoneDeclarerNameSpace, 'CQL_FILTER': filter , 'STYLES': style},
      ratio: 1,
      serverType: 'geoserver',

    });
    this.sourceLayerClic = new ImageLayer({
      // extent: [-13884991, 2870341, -7455066, 6338219],
      source: mwsSourcesnup,
      opacity: 0.8,
      visible: true,
      // minZoom: 18


    })
    return this.sourceLayerClic;*/
    const source = new ImageWMS({
      url: this.url,
      params: {
        'LAYERS': layerName,
        'CQL_FILTER': cqlFilter,
        'VERSION': '1.1.1',
        'STYLES': style
      },
      serverType: 'geoserver',
      ratio: 1,
    });

    const layer = new ImageLayer({
      source: source,
    });
    this.map.addLayer(layer);
  }


  builSourceWms(layerName, cqlFilter?, style?){
    const source = new ImageWMS({
      url: this.url,
      params: {
        'LAYERS': layerName,
        'CQL_FILTER': cqlFilter,
        'VERSION': '1.1.1',
        'STYLES': style
      },
      serverType: 'geoserver',
      ratio: 1,
    });
    return source;
  }




  getGeoPoistion() {
    console.log('getGeoPoistion')
    if (this.enablegeoLocation) {
      this.enablegeoLocation = false;
    } else {
      this.enablegeoLocation = true;
    }
    this.loading = true ;
    const geolocation = new Geolocation({
      tracking: true,
      trackingOptions: {
        enableHighAccuracy: true
        // maximumAge: 2000
      },
      projection: this.map.getView().getProjection()
    });
    if (this.enablegeoLocation) {

      geolocation.on('change', () => {
        const position = geolocation.getPosition();
        this.accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
        console.log(position);
        this.positionFeature.setGeometry(position ?
          new Point(position) : null);
        this.map.getView().setCenter(position);
        this.map.getView().setZoom(15);
        const vectorSource = new VectorSource();
        vectorSource.addFeature(this.positionFeature);
        // this.map.getLayers().array_.push(this.positionFeature)
        // this.map.getView().fit(vectorSource.getExtent());
        // Mettez à jour la position de l'élément radar en fonction de la nouvelle position.
        this.radarActive = true;
        //@ts-ignore
        this.radarStyle = {
          left: position[0] - 25 + 'px',
          top: position[1] - 25 + 'px'
        };

        new VectorLayer({
          map: this.map,
          source: new VectorSource({
            features: [this.accuracyFeature, this.positionFeature],
          }),
        });
        this.loading = false;

      });
      geolocation.on("error", () => {

          setTimeout(() => {
            this._snackBar.open("Une erreur s'est produit", "Fermer");
          }, 3000);


      })


    } else {
      geolocation.setTracking(false);
      window.location.reload()
    }

  }

  searchFeature(event: any) {
    console.log(event)
    if (event.code.includes(",")) {
      // console.log(' searching by coordinates')
      var splitSearch = event.code.split(",").map((element) => element.trim());
      // console.log('x ', splitSearch[0], 'y', splitSearch[1])
      // this.initilizeMap()
      this.flyTo([splitSearch[0], splitSearch[1]], function () {
      }, 12)
      /* this.sourceLayers.setVisible(true)
       this.sourceLayersnum.setOpacity(1)
       this.sourceLayersnum.setZIndex(1)
       this.map.setView(new View({
         center: [splitSearch[0], splitSearch[1]],
         projection: 'EPSG:32631',
         zoom: 10,
         minZoom: 8
       }))*/
    } else {
      if (event.code.length === 9) {
        this.searchByNup(event.code)
      }
    }
  }
// find searchFeature
  searchByNup(keys) {
    this._appServices.getNupInfo(keys).subscribe((res: SpacialData) => {
      if (res.message === "ParcelExists") {
        let data = res.data;
        this.extractedDataInformation(data);
        this.map.removeLayer(this.sourceLayerClic)
        this.map.getLayers().array_.push(this.clicLayer(keys))
        // this.clicLayer(keys)
        this.flyTo([data.coordinate.x, data.coordinate.y], () => {
          // this.getInfoFromLocalStorage(d)
          this.openModal()
        }, this.getZoom(data.calculatedArea))
        // this._router.navigate(["/nup", keys])\
        // this.village = "'" + d.quartierName + "'"
        /* this.village = d.quartierName
         console.log(this.village)
         this.nup = d.nup;
         this.Tfoncier = d.titleNumberNumber;
         this.Dep = d.departementName;
         this.Com = d.communeName;
         this.Arr = d.arrondissementName;
         this.Qrtier = d.quartierName;
         this.lot = d.ilot;
         this.Surface = d.calculatedArea;
         this.Parcelle = d.registerType;

         if (this.Parcelle === "publicDomain") {
           this.Parcelle = 'Domaine public'
         } else if (this.Parcelle === "privateParcel") {
           this.Parcelle = 'Parcelle privée'
         } else if (this.Parcelle === "naturalPublicDomain") {
           this.Parcelle = 'Domaine public naturel'
         } else if (this.Parcelle === "artificialPublicDomain") {
           this.Parcelle = 'Domaine public artificiel'
         }
         this.DateF = "-";*/
        // $("#myModal").modal('show')
        // this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Parcelle trouvée", "Fermer",);
        }, 3000);
      } else if (res.message === "ParcelNotExists") {
        this.initilizeMap()
        setTimeout(() => {
          this._snackBar.open("Parcelle non trouvée", "Fermer");
        }, 3000);

      }

    })


  }

  getTypeParcel(registerType: string | undefined): string {
    switch (registerType) {
      case 'publicDomain' :
        return 'Domaine public';
        break
      case 'privateParcel':
        return 'Parcelle privée';
        break
      case 'naturalPublicDomain':
        return 'Domaine public naturel';
        break
      case 'artificialPublicDomain':
        return 'Domaine public artificiel';
        break
      default:
        return "";
    }
  }

  openModal() {
    console.log('open')
    $('#exampleModalInitialisationDetails').modal('show')
    // $("#exampleModalInitialisation").modal('show')
    // const myModal = document.getElementById('exampleModalInitialisation')
    // const modal = new bootstrap.Modal(myModal)
    // modal.show();

  }

  private getZoom(calculatedArea: number) {
    let zoom = 15;
    if (calculatedArea < 500) {
      zoom = 20;
    } else if (calculatedArea > 500 && calculatedArea < 10000) {
      zoom = 19;
    } else if (calculatedArea > 10000 && calculatedArea < 50000) {
      zoom = 17;
    } else if (calculatedArea > 50000) {
      zoom = 15;
    }
    return zoom;
  }

  layesSelected(event: any) {
    console.log('layesSelected', event)
    if (event.value === 'osm') {
      this.setVisisibleLayerOsm();
    }else if (event.value === 'google'){
      this.setVisibleLayerGoogle();
    }
  }

  setVisisibleLayerOsm(){
    this.osmLayers.setVisible(true)
    this.beninOrthoLayer.setVisible(false)
    this.googleStatLayers.setVisible(false)
    this.olgmLayers.setVisible(false)
  }

  setVisibleLayerGoogle(){
    this.osmLayers.setVisible(false)
    this.beninOrthoLayer.setVisible(false)
    this.googleStatLayers.setVisible(true)
    this.olgmLayers.setVisible(true)
  }


  buildZonDeclare(){
   this.zoneDeclareLayersZhs = new ImageLayer({
      source:this.builSourceWms(this.zoneDeclarerNameSpace,"zone_declaree_type='Zone de haute sécurité frontalière'",'zhsf'),
     visible: false
    });
    this.map.addLayer(this.zoneDeclareLayersZhs);

    this.zoneDeclareLayersDpn = new ImageLayer({
      source:this.builSourceWms(this.zoneDeclarerNameSpace,"zone_declaree_type='Domaine public naturel'",'dnp'),
     visible: false
    });
    this.map.addLayer(this.zoneDeclareLayersDpn);

    this.zoneDeclareLayersPag = new ImageLayer({
      source:this.builSourceWms(this.zoneDeclarerNameSpace,"zone_declaree_type='PAG'",'pag'),
     visible: false
    });
    this.map.addLayer(this.zoneDeclareLayersPag);

    this.zoneDeclareLayersZdup = new ImageLayer({
      source:this.builSourceWms(this.zoneDeclarerNameSpace,"zone_declaree_type='ZDUP'",'zdup'),
     visible: false
    });
    this.map.addLayer(this.zoneDeclareLayersZdup);

  }

  changeAdditionalLayer(event: any) {
    console.log('changeAdditionalLayer', event)
    if (typeof this.zoneDeclareLayersPag === 'undefined'
      || typeof this.zoneDeclareLayersZhs === 'undefined'
      || typeof this.zoneDeclareLayersZdup === 'undefined'
      || typeof this.zoneDeclareLayersDpn === 'undefined'
    ) {
      this.buildZonDeclare()
    }

      this.zoneDeclareLayersZhs.setVisible(event.zsf)
   /* if(event.zsf){
      this.zoneDeclareLayersZhs.setVisible(true)
       // this.buildAddionnional(this.zoneDeclarerNameSpace,"zone_declaree_type='Zone de haute sécurité frontalière'",'sst')
    }else {
      this.zoneDeclareLayersZhs.setVisible(false)
    }*/
    this.zoneDeclareLayersPag.setVisible(event.pag)

    /* if(event.pag){
      this.buildAddionnional(this.zoneDeclarerNameSpace,"zone_declaree_type='PAG'",'sst')

      // this.map.getLayers().array_.push(this.buildAddionnional('zone_declaree_type=PAG','sst'))
    }*/
    this.zoneDeclareLayersZdup.setVisible(event.zdup);
   /* if(event.zdup){
      // this.map.getLayers().array_.push(this.buildAddionnional('zone_declaree_type=ZDUP','sst'))
      this.buildAddionnional(this.zoneDeclarerNameSpace,"zone_declaree_type='ZDUP'",'sst')

    } */
    this.zoneDeclareLayersDpn.setVisible(event.dpn)
   /* if(event.dpn){
      this.buildAddionnional(this.zoneDeclarerNameSpace,"zone_declaree_type='Domaine public naturel'",'sst')

      // this.map.getLayers().array_.push(this.buildAddionnional('zone_declaree_type=Domaine public naturel','sst'))
    }*/
    // this.buildAddionnional(this.zoneDeclarerNameSpace,encodeURIComponent(""),'sst')

  }


  decodeArray(local_parcel_identification: string[] | undefined) {
    console.log(local_parcel_identification)
    let a= ''
    local_parcel_identification.forEach((value) => {
      console.log(value);
      a = a + value;
    });
    return a;
  }
}
